<!-- @format -->

<template>
  <div>
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>
                <span v-if="plan.status == 98">
                  <span> <i class="ui icon circle "></i> </span>
                </span>
                <span v-if="plan.status == 99">
                  <span>
                    <i class="ui icon circle " style="color: lightgrey"></i>
                  </span>
                </span>
                <span v-else-if="plan.status == 1"
                  ><i class="ui icon circle " style="color: green"></i>
                </span>
                <span v-else-if="plan.status == 0">
                  <span>
                    <i class="ui icon circle " style="color: red"></i>
                  </span> </span
                >{{ plan.proposalName }}
              </h2>
              created as at {{ plan.createdAsAt }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div class="ui secondary pointing menu">
              <a
                class="ui item"
                v-bind:style="tab == 0 ? 'border-color:#000000!important' : ''"
                v-bind:class="{ active: tab == 0 }"
                @click.prevent="tab = 0"
                >Key Info</a
              >
              <a
                class="ui item"
                v-bind:style="tab == 1 ? 'border-color:#000000!important' : ''"
                v-bind:class="{ active: tab == 1 }"
                @click.prevent="tab = 1"
                >Share</a
              >
              <a
                class="ui item"
                v-bind:style="tab == 2 ? 'border-color:#000000!important' : ''"
                v-bind:class="{ active: tab == 2 }"
                @click.prevent="getAuditTrails()"
                >Audit trails</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui twelve column padded grid centered">
      <div class="row">
        <div class="twelve wide column">
          <div>
            <div v-if="tab == 0">
              <div class="twelve wide column">
                <div class="ui segment">
                  <table class="ui table">
                    <thead>
                      <tr>
                        <th colspan="2">Details</th>
                      </tr>
                    </thead>

                    <tr class="ui">
                      <td style="width: 150px"><strong>Status</strong></td>
                      <td>
                        <span v-if="plan.status == 98">
                          <span>
                            <i
                              class="ui icon circle "
                              style="color: lightgrey"
                            ></i>
                            Draft
                          </span>
                        </span>
                        <span v-if="plan.status == 99">
                          <span>
                            <i
                              class="ui icon circle "
                              style="color: orange"
                            ></i>
                            Awaiting Signature</span
                          >
                        </span>
                        <span v-else-if="plan.status == 1"
                          ><i class="ui icon circle " style="color: green"></i>
                          Accepted
                        </span>
                        <span v-else-if="plan.status == 0">
                          <span>
                            <i class="ui icon circle " style="color: red"></i>
                            Rejected
                          </span></span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Name</strong></td>
                      <td>{{ plan.proposalName }}</td>
                    </tr>
                    <tr>
                      <td><strong>Description</strong></td>
                      <td>{{ plan.proposalDescription }}</td>
                    </tr>
                    <tr v-if="plan.customCoverText">
                      <td colspan="2">
                        <div class="ui form">
                          <div class="ui field">
                            <label>Custom cover text</label>
                            <textarea
                              readonly
                              rows="7"
                              v-model="plan.customCoverText"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Created </strong></td>
                      <td>{{ plan.createdAsAt }} by {{ plan.createdBy }}</td>
                    </tr>
                    <tfoot>
                      <tr>
                        <th colspan="2">
                          <a target="_blank" :href="proposalUrlColleague">
                            <i class="ui external alternate icon"></i> View
                            Interactive Plan</a
                          >
                          <span v-if="pdfUrl">
                            |
                            <a
                              @click.prevent="downloadFile('Default')"
                              href="#"
                            >
                              <i class="ui download icon"></i> Download Pdf
                            </a></span
                          >
                          <span v-if="pdfUrlAfrikaans">
                            |
                            <a
                              @click.prevent="downloadFile('Afrikaans')"
                              href="#"
                            >
                              <i class="ui download icon"></i> Download Pdf
                              (Afr)
                            </a></span
                          >
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div v-if="tab == 1">
              <div class="twelve wide column">
                <div class="ui tabular attached menu">
                  <a
                    href="#"
                    @click.prevent="share('client')"
                    :class="
                      shareWith == 'client' ? 'ui active item' : 'ui item'
                    "
                    >Share with Client</a
                  >
                  <a
                    href="#"
                    @click.prevent="share('colleague')"
                    :class="
                      shareWith == 'colleague' ? 'ui active item' : 'ui item'
                    "
                    >Share with Colleague</a
                  >
                  <a
                    href="#"
                    @click.prevent="share('external')"
                    :class="
                      shareWith == 'external' ? 'ui active item' : 'ui item'
                    "
                    >Share with External party</a
                  >
                </div>

                <div
                  v-if="shareWith == 'client'"
                  class="ui bottom attached segment"
                >
                  <table class="ui table">
                    <thead>
                      <tr>
                        <th colspan="2">Access Details</th>
                      </tr>
                    </thead>
                    <tr>
                      <td style="width: 200px">Unique Link</td>
                      <td>{{ proposalUrl }}</td>
                    </tr>
                    <tr>
                      <td>Access Code</td>
                      <td>{{ plan.clientPwd }}</td>
                    </tr>
                  </table>

                  <div class="ui attached message">
                    Here is some suggested text which you can send to your
                    client.
                  </div>
                  <div class="ui attached segment">
                    <div class="ui ">
                      <span ref="htmlMessage" v-html="htmlMessage"></span>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <a class="ui label" @click.prevent="copyURL"
                      ><i class="ui copy outline icon"></i> Copy text
                    </a>
                  </div>
                </div>
                <div
                  v-if="shareWith == 'colleague'"
                  class="ui bottom attached segment"
                >
                  <table class="ui table">
                    <thead>
                      <tr>
                        <th colspan="2">Access Details</th>
                      </tr>
                    </thead>
                    <tr>
                      <td style="width: 200px">Unique Link</td>
                      <td>{{ proposalUrlColleague }}</td>
                    </tr>
                  </table>
                </div>
                <div
                  v-if="shareWith == 'external'"
                  class="ui bottom attached segment"
                >
                  <table class="ui table">
                    <thead>
                      <tr>
                        <th colspan="2">Access Details</th>
                      </tr>
                    </thead>
                    <tr>
                      <td style="width: 200px">Unique Link</td>
                      <td>{{ proposalExternalUrl }}</td>
                    </tr>
                    <tr>
                      <td>Access Code</td>
                      <td>{{ plan.externalPwd }}</td>
                    </tr>
                  </table>

                  <div class="ui attached message">
                    Here is some suggested text which you can send to the
                    external party (e.g auditors)
                  </div>
                  <div class="ui attached segment">
                    <div class="ui ">
                      <span
                        ref="htmlMessage"
                        v-html="htmlExternalMessage"
                      ></span>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <a class="ui label" @click.prevent="copyExternalURL"
                      ><i class="ui copy outline icon"></i> Copy text
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tab == 2">
              <div class="twelve wide column">
                <table v-if="auditTrails" class="ui table">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Event description</th>
                    </tr>
                  </thead>
                  <tr v-for="a in auditTrails" v-bind:key="a.id">
                    <td>{{ a.createdAsAt }}</td>
                    <td>{{ a.event }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <a href="#" class="ui button" @click.prevent="clickBack()">Back</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";

// @ is an alias to /src
import {
  getAuthenticatedClientProposal,
  ProposalUrl,
  getProposalAudit,
  downloadProposalPlan,
} from "@/gateway";

export default {
  name: "home",
  components: {},
  computed: {
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
  },
  data() {
    return {
      pdfUrl: "",
      pdfUrlAfrikaans: "",
      auditTrails: [],
      plainMessage: "",
      plainExternalMessage: "",
      htmlMessage: "",
      htmlExternalMessage: "",
      proposalExternalUrl: "",
      proposalUrlColleague: "",
      proposalUrl: "",
      id: 0,
      tab: 0,
      disableForm: true,
      results: null,
      loading: false,
      message: null,
      plan: null,
      goals: [],
      shareWith: "client",
    };
  },
  methods: {
    async downloadFile(typ) {
      const response = await downloadProposalPlan({
        guid: this.plan.guid,
        type: typ,
      });
      if (response) {
        var byteArray = this.base64ToArrayBuffer(response.data);

        const url = window.URL.createObjectURL(
          new Blob([byteArray], { type: "application/octet-stream" })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.fileName);
        document.body.appendChild(link);

        link.click();
      }
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    clickBack() {
      this.$router.go(-1);
    },
    share(val) {
      this.shareWith = val;
    },
    copyURL() {
      var copyLink = this.plainMessage; // this.$refs.htmlMessage.textContent;
      // var f = copyLink.replace(/<br>/g, "\n").replace(/<\/?[^>]+>/g, "");
      const el = document.createElement("textarea");

      el.value = copyLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        this.$notify({
          group: "client",
          title: "Text copied to clipboard",
          position: "bottom right",
          type: "success",
        });
      }
    },
    copyExternalURL() {
      var copyLink = this.plainExternalMessage; // this.$refs.htmlMessage.textContent;
      // var f = copyLink.replace(/<br>/g, "\n").replace(/<\/?[^>]+>/g, "");
      const el = document.createElement("textarea");

      el.value = copyLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        this.$notify({
          group: "client",
          title: "Text copied to clipboard",
          position: "bottom right",
          type: "success",
        });
      }
    },

    async getAuditTrails() {
      this.tab = 2;
      const response = await getProposalAudit({ proposalGuid: this.id });

      if (response) this.auditTrails = response.result;
    },
    getImage(val) {
      var imageBaseUrl =
        "https://acportfoliolink.blob.core.windows.net/assets/";
      if (val.toLowerCase().includes("education"))
        return imageBaseUrl + "Education_32px.svg";
      else if (val.toLowerCase().includes("travel"))
        return imageBaseUrl + "Travel-Holiday_32px.svg";
      else if (val.toLowerCase().includes("retirement"))
        return imageBaseUrl + "Retirement_32px.svg";
      else if (val.toLowerCase().includes("emergency"))
        return imageBaseUrl + "Emergency_32px.svg";
    },

    editClick: function() {
      this.disableForm = !this.disableForm;
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    async getResults() {
      this.loading = true;
      var response = await getAuthenticatedClientProposal({
        guid: this.$route.params.id,
      });
      if (response) {
        this.results = response;
        this.plan = response.result;
        this.pdfUrl = response.pdfUrl;
        this.pdfUrlAfrikaans = response.pdfUrlAfrikaans;
        //  this.clientDetails = response.client;
        this.htmlMessage =
          "<p>Dear " +
          this.results.client.firstName +
          ", <br /><br /> as discussed here is your investment plan. Please review it and accept/reject it.  </p>" +
          "<p> You can view it here: <strong><a :href='" +
          this.proposalUrl +
          "'></strong>" +
          this.proposalUrl +
          "</a>.<br /> Access code: <strong>" +
          this.plan.clientPwd +
          " </strong></p><br /> Kind regards <br /> <br />";

        this.plainMessage =
          "Dear " +
          this.results.client.firstName +
          ", \r\n \r\n as discussed here is your investment plan. Please review it and accept or reject it. " +
          "\r\n - You can view it here: " +
          this.proposalUrl +
          "\r\n - Access Code: " +
          this.plan.clientPwd +
          "\r\n  \r\n Kind regards ";

        this.htmlExternalMessage =
          "<p>as discussed here is " +
          this.results.client.firstName +
          " " +
          this.results.client.lastName +
          "'s investment plan.</p>" +
          "<p> You can view it here: <strong><a :href='" +
          this.proposalExternalUrl +
          "'></strong>" +
          this.proposalExternalUrl +
          "</a>.<br /> Access code: <strong>" +
          this.plan.externalPwd +
          " </strong></p><br /> Kind regards <br /> <br />";

        this.plainExternalMessage =
          "as discussed here is " +
          this.results.client.firstName +
          " " +
          this.results.client.lastName +
          "'s investment plan." +
          "\r\n - You can view it here: " +
          this.proposalExternalUrl +
          "\r\n - Access Code: " +
          this.plan.externalPwd +
          "\r\n  \r\n Kind regards ";

        this.loading = false;
      }
      // load client goals
    },
  },
  mounted: function() {
		var domainName = "portfoliolink.co.za";
		if (this.$store.state.appName.toLowerCase() == "questlink")
		{
			domainName = "questlink.app";
		}
    this.proposalUrl = ProposalUrl.replace("portfoliolink.co.za",domainName) + "?g=" + this.$route.params.id;
    this.proposalUrlColleague = ProposalUrl.replace("portfoliolink.co.za",domainName) + "?c=" + this.$route.params.id;
    this.proposalExternalUrl = ProposalUrl.replace("portfoliolink.co.za",domainName) + "?e=" + this.$route.params.id;
    this.id = this.$route.params.id;
    this.getResults();
  },
};
</script>
<style lang="css" scoped></style>
